export default {
  horizontal: {
    name: 'horizontal',
  },
  vertical: {
    name: 'vertical',
  },
};
